<template>
	<div class="container">
		<div class="content">
			<Activity :list="activityList"/>
			<div class="pagination-wrap">
				<el-pagination
				  background
				  layout="prev, pager, next"
				  :page-size= this.pageSize
				  :total=this.total
				  @current-change="handleCurrentChange"
				  hide-on-single-page
				  >
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import Activity from '@/components/activity'
	export default {
		name: 'activity',
		components: {
			Activity
		},
		data(){
			return {
				activityList: [],
				pageNum: 1,
				pageSize: 10,
				total: 0
			}
		},
		created(){
			this.getActivityList()
		},
		methods: {
			handleCurrentChange(e){
				this.activityList = []
				this.pageNum = e
				this.getActivityList()
			},
			//获取活动
			async getActivityList(){
				console.log('-----------')
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/vacation/myVacationCenterList', qs.stringify(param))
				if(res.data.code==200){
					this.activityList = res.data.page.items
					this.total =  res.data.page.count
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>

<style scoped lang="less">

</style>
